import React, { memo, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Form, Radio, Button } from 'antd';

// utils
import { getUndertakeLabel } from "utils/helpers/helper.generateData";
import _local from "utils/localStorageUtils";

function ParentsUndertakeForm({
  formData,
  isNew,
  isEdit,
  // actions
  nextStep,
  prevStep,
  goToStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames('form-absence', className);
  const { t, i18n } = useTranslation();

  const localUser = _local.getLocalUser();

  const [isDisabled, setIsDisabled] = useState(true);

  const [AbsFormUndertake] = Form.useForm();

  useEffect(() => {
    if (formData && formData?.parents_undertake) {
      AbsFormUndertake.setFieldsValue(formData);
      setIsDisabled(false);
    }
  }, [formData]);

  const onFinish = values => {
    result(values);
    nextStep !== undefined && nextStep();
    AbsFormUndertake.resetFields();
  };

  const getOptions = useCallback(() => (
    [
      {
        key: 'with-parent',
        value: 'with-parent',
        label: (
          <>
            <span className="label__description">
              {getUndertakeLabel("with-parent")}
            </span>
          </>
        ),
      },
      {
        key: 'alone',
        value: 'alone',
        label: (
          <>
            <span className="label__description">
              {getUndertakeLabel("alone")}
            </span>
          </>
        ),
      },
    ]
  ), []);i18n?.language

  const goMediaStep = () => {
    const absenceData = !!!isEdit?._id && formData || !!isEdit?._id && !formData?._id && isEdit || !!isEdit?._id && !!formData?._id && formData || formData;
    const hasMedia =
      !absenceData?.media || (absenceData?.media && absenceData?.media.length <= 0);
    const fomrMediaStep = isEdit && localUser?.role == "parent" ? 1 : 4;
    const previewMediaStep = isEdit && localUser?.role == "parent" ? 2 : 5;
    goToStep(hasMedia ? fomrMediaStep : previewMediaStep);
  };

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormUndertake}
        className="form-absence__form"
        name="form_absence_undertake"
        initialValues={{}}
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <Form.Item name="parents_undertake">
          <Radio.Group
            className="radio-group radio-group--big"
            options={getOptions()}
            optionType="Radio"
          />
        </Form.Item>

        <div className="absence-actions-wrapper">
          <Button
            className="btn-previous"
            onClick={() => goMediaStep()}
          >
            {t("common.previous")}
          </Button>
          <Button
            className="next-btn"
            form="form_absence_undertake"
            htmlType="submit"
            disabled={isDisabled}
          >
            {t("common.next")}
          </Button>
        </div>
      </Form>
    </div>
  );
}

ParentsUndertakeForm.defaultProps = {};
ParentsUndertakeForm.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};

export default memo(ParentsUndertakeForm);
